import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullStarIcon from "static/svg/header/customers/filled_star.svg";
import PartiallyFullStarIcon from "static/svg/header/customers/partially_filled_star.svg";
import G2Logo from "static/svg/header/customers/g2.svg";
import TrustRadiusLogo from "static/svg/header/customers/Trustradius.svg";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledSocialProofComponent } from "./social-proof-component.scss";
const SocialProofComponent = ({ translate })=>{
    return /*#__PURE__*/ _jsxs(StyledSocialProofComponent, {
        className: "social-proof-component",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "stars",
                children: [
                    /*#__PURE__*/ _jsx(FullStarIcon, {}),
                    /*#__PURE__*/ _jsx(FullStarIcon, {}),
                    /*#__PURE__*/ _jsx(FullStarIcon, {}),
                    /*#__PURE__*/ _jsx(FullStarIcon, {}),
                    /*#__PURE__*/ _jsx(PartiallyFullStarIcon, {})
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "reviews-text",
                children: translate("header.tabs.customers.section.bottomPart.socialProofText")
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "logo-wrapper",
                children: /*#__PURE__*/ _jsx(G2Logo, {
                    height: "19",
                    width: "19"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "logo-wrapper",
                children: /*#__PURE__*/ _jsx(TrustRadiusLogo, {
                    height: "15",
                    width: "auto"
                })
            })
        ]
    });
};
export default withGenericConfig(SocialProofComponent);
